const ShipslandServiceList = [
    {
        id:1,
        name: 'Hizmetler',
        items: [ {
            id : 1,
            name: 'Lojistik',
            items: [
                {
                    id:1,
                    name: 'Türkiye-Uluslararası',
                    items:[
                        {
                            id:1,
                            name:"TR-Uluslararası Ekspres"
                        },{
                            id:2,
                            name:"TR-Uluslararası Eko (Küçük Paket)"
                        },{
                            id:3,
                            name:"TR-EU (DDP)"
                        },{
                            id:4,
                            name:"TR-USA Daha Az Konteyner Yükü (DDP)"
                        }
                    ]
                },{
                    id:2,
                    name: 'Çin-Uluslararası',
                    items:[
                        {
                            id:1,
                            name:"Çin-Uluslararası Ekspres",
                        },{
                            id:2,
                            name:"Çin-Türkiye",
                            items:[
                                {
                                    id:1,
                                    name:"Küçük Paket (DDP)"
                                },{
                                    id:2,
                                    name:"Örnek (DDP)"
                                },{
                                    id:3,
                                    name:"Ekspres (DDP)"
                                }
                            ]
                        },{
                            id:3,
                            name:"Çin-Uluslararası Eko (Küçük Paket)"
                        }
                    ]
                },{
                    id:3,
                    name: 'ABD-Uluslararası',
                    items:[
                        {
                            id:1,
                            name:"ABD Yurtiçi (LTL)"
                        },{
                            id:2,
                            name:"ABD-Türkiye (Küçük Paket / DDP)"
                        },{
                            id:3,
                            name:"ABD Yurtiçi (Küçük Paket)"
                        },{
                            id:4,
                            name:"ABD Uluslararası"
                        }
                    ]
                }
            ]
        },{
            id : 2,
            name: 'Tamamlama',
            items: [
                {
                    id:1,
                    name: 'ABD Depo'
                },{
                    id:2,
                    name: 'Çin Deposu'
                },{
                    id:3,
                    name: 'Almanya Depo'
                },{
                    id:4,
                    name: 'Türkiye Depo'
                }
            ]
        }]
    },{
        id:2,
        name: 'Fiyat'
    },{
        id:3,
        name: 'Bizimle iletişime'
    }
   
];

export default ShipslandServiceList;